"use client"

import { env } from "next-runtime-env"
import { useTheme } from "next-themes"
import { Link } from "next-view-transitions"
import Image from "next/image"
import { usePathname, useSearchParams } from "next/navigation"

import { buildRedirectUrl } from "@/lib/new-url"
import { useMounted } from "@/lib/useMounted"

import ThemeButton from "@/components/themeButton"
import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"

import { TSP_CONFIG } from "@/app/tsp/config"

export default function TspNavbar() {
  const path = usePathname()
  const searchParams = useSearchParams()
  const mounted = useMounted()
  const { theme } = useTheme()
  const version = env("NEXT_PUBLIC_VERSION")

  const redirect = searchParams.get("redirect")
  const loginHref =
    redirect && TSP_CONFIG.LOGIN_URL
      ? buildRedirectUrl(TSP_CONFIG.LOGIN_URL, redirect)
      : TSP_CONFIG.LOGIN_URL
  const signupHref =
    redirect && TSP_CONFIG.SIGNUP_URL
      ? buildRedirectUrl(TSP_CONFIG.SIGNUP_URL, redirect)
      : TSP_CONFIG.SIGNUP_URL

  const showLogin = TSP_CONFIG.LOGIN_URL && TSP_CONFIG.LOGIN_URL !== path
  const showSignup = TSP_CONFIG.SIGNUP_URL && TSP_CONFIG.SIGNUP_URL !== path

  return (
    <header className="container select-none">
      <nav className="justify-between md:flex md:items-center">
        <div>
          <div className="flex justify-between py-3 md:block md:py-5">
            <Link href="/">
              {mounted && (
                <Image
                  src={
                    theme === "dark"
                      ? TSP_CONFIG.ICON_DARK
                      : TSP_CONFIG.ICON_LIGHT
                  }
                  alt="Logo"
                  width={1492}
                  height={914}
                  className="h-10 w-auto cursor-pointer"
                />
              )}
            </Link>
            <div className="flex flex-row items-center gap-2 md:hidden">
              <Button asChild size="sm" variant="ghost">
                <Link href="/blog">Blog</Link>
              </Button>
              <ThemeButton />
              {showLogin ? (
                <Button asChild size="sm" variant="outline">
                  <a href={loginHref}>Log in</a>
                </Button>
              ) : null}
              {showSignup ? (
                <Button asChild size="sm">
                  <a href={signupHref}>Sign up</a>
                </Button>
              ) : null}
            </div>
          </div>
        </div>
        <div className="flex flex-row-reverse items-center justify-between gap-2">
          {showSignup ? (
            <Button asChild className="hidden md:flex" size="sm">
              <a href={signupHref}>Sign up</a>
            </Button>
          ) : null}
          {showLogin ? (
            <Button
              asChild
              className="hidden md:flex"
              size="sm"
              variant="outline"
            >
              <a href={loginHref}>Log in</a>
            </Button>
          ) : null}
          <ThemeButton className="hidden md:flex" />
          <Button asChild className="hidden md:flex" size="sm" variant="ghost">
            <Link href="/blog">Blog</Link>
          </Button>
          {version ? (
            <Badge
              variant="outline"
              className="hidden h-6 md:flex md:items-end"
            >
              {version}
            </Badge>
          ) : null}
        </div>
      </nav>
    </header>
  )
}
